import { instance } from "@/apis";
import { useMutation } from "@tanstack/react-query";

export const useDeleteChatMemoMutation = () => {
  return useMutation({
    mutationFn: ({ chatId, memoId }: { chatId: string; memoId: string }) =>
      instance.delete(`/api/df/user/chat/${chatId}/memo/${memoId}`),
  });
};
